import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const services = [
  { icon: FiIcons.FiHome, label: 'Appartamenti e Case' },
  { icon: FiIcons.FiBox, label: 'Cantine e Solai' },
  { icon: FiIcons.FiTruck, label: 'Garage e Box' },
  { icon: FiIcons.FiBriefcase, label: 'Uffici e Locali' },
  { icon: FiIcons.FiLayers, label: 'Magazzini e Capannoni' },
  { icon: FiIcons.FiMap, label: 'Traslochi (Secondario)' },
];

export default function ServicesBar() {
  return (
    <section className="bg-maaich-black border-y border-white/10 py-8 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-x-12 gap-y-8">
          {services.map((service, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex items-center gap-3 group cursor-default"
            >
              <div className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white group-hover:border-maaich-lime group-hover:text-maaich-lime transition-colors duration-300">
                <SafeIcon icon={service.icon} className="text-xl" />
              </div>
              <span className="font-display text-lg uppercase italic text-white/80 group-hover:text-white transition-colors duration-300">
                {service.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}